<template>
  <!-- Schedule a Session modal -->
  <div
    class="modal fade scheduleModal"
    id="sessionModal"
    tabindex="-1"
    aria-labelledby="sessionModalLabel"
    aria-hidden="true"
    ref="scheduleModal"
  >
    <div class="modal-dialog modal-dialog-scrollable opacity-animate3" :class="isScheduled ? 'modal-sm' : 'modal-lg'">
      <div class="modal-content">
        <div class="modal-header" v-if="!isScheduled">
          <button type="button" class="custom-close" data-bs-dismiss="modal" aria-label="Close"> <i class="ph-x-bold"></i> </button> 
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row" v-if="isScheduled">
              <div class="thankYou-container">
                <div class="thankYou-body">
                  <img src="/assets/img/ReferThankYou.png" />
                  <p>We will be in touch soon.</p>
                </div>
                <div class="button-container">
                  <a href="javascript:void(0)" type="button" class="btn-primaryNoIcon md-primarynoIcon" data-bs-dismiss="modal"
                    aria-label="Close">Got it</a>
                </div>
              </div>
            </div>
            <div class="row" v-if="!isScheduled">
              <div class="col-sm-12">
                <div class="schedule-container">
                  <div class="scheduleSlider">
                    <!-- slide 01 -->
                    <div>
                      <div class="schedule-box">
                        <div class="schedule-image-container">
                          <img src="/img/scheduleSession-image01.webp" alt="" />
                        </div>
                        <div class="schedule-content">
                          <div class="upper-content">
                            <p class="schedule-caption">
                              Expert guidance tailored for you
                            </p>
                            <p class="schedule-info">
                              Our experienced financial coaches have guided thousands of
                              people. In this session, our financial coach will guide you
                              and create a plan tailor-made for you.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- slide 02 -->
                    <div>
                      <div class="schedule-box">
                        <div class="schedule-image-container">
                          <img src="/img/scheduleSession-image02.webp" alt="" />
                        </div>
                        <div class="schedule-content">
                          <div class="upper-content">
                            <p class="schedule-caption">Free of charge</p>
                            <p class="schedule-info">
                              This session is free of charge, and you can attend it online
                              without leaving the comfort of your home, which makes it
                              hassle-free.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- slide 03 -->
                    <div>
                      <div class="schedule-box">
                        <div class="schedule-image-container">
                          <img src="/img/scheduleSession-image03.webp" alt="" />
                        </div>
                        <div class="schedule-content">
                          <div class="upper-content">
                            <p class="schedule-caption">Best-suited options</p>
                            <p class="schedule-info">
                              Our financial coach will suggest options most suitable for
                              you considering your goals, risk-taking ability, and time
                              horizon.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slider-progress">
                    <div class="progresss"></div>
                  </div>
                  <div class="progress-round__wrap">
                    <svg width="165" height="165" class="progresss">
                      <circle cx="81" cy="80" r="80" />
                    </svg>
                  </div>
                </div>
                <div class="plan-future-container">
                  <div class="container-fluid p-0">
                    <!-- FORM ERROR -->
                    <div class="row" v-if="errors['form_error'] && errors['form_error'] !== ''">
                      <div class="col-sm-12">
                        <div class="hf_input-container">
                          <p class="errorMessage">
                            <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                            {{ errors["form_error"] }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <!--END FORM ERROR -->
                    <form id="scheduleASessionForm">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group hf_input-container">
                            <label for="name">Name <span class="hf_primary">*</span></label > 
                            <input type="text" id="fullName" class="form-control hf_customInput" v-model="fullname" maxlength="100" placeholder="Enter your name"/>
                            <!-- error message -->
                            <p class="errorMessage" v-if="errors['fullname'] && errors['fullname'] !== ''">
                              <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                              {{ errors["fullname"] }}
                            </p> 
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group hf_input-container">
                            <label for="email">Email <span class="hf_primary">*</span></label > 
                            <input type="email" id="emailAddress" class="form-control hf_customInput" v-model="email_address" maxlength="100" placeholder="Enter your email"/> 
                            <!-- error message -->
                            <p class="errorMessage" v-if="errors['email_address'] && errors['email_address'] !== ''">
                              <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                              {{ errors["email_address"] }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group hf_input-container abc">
                            <label for="number">Mobile <span class="hf_primary">*</span></label>
                            <div class="country-code-container">
                              <span class="plus-code">+</span>
                              <input type="number" id="countryCode" class="form-control hf_customInput conCode" v-model="country_code" :maxlength = "maxCountryCodeLength"/>
                              <input type="number" id="mobileNumber" class="form-control hf_customInput telNo" v-model="mobile_number" @keypress="isMobileNumber($event)" oninput="javascript: if (this.value.length >this.maxLength) this.value = this.value.slice(0, this.maxLength);" :maxLength = "maxMobileLength" placeholder="Enter your mobile number"/>
                            </div>
                            <!-- error message -->
                            <p class="errorMessage" v-if="errors['mobile_number'] && errors['mobile_number'] !== ''">
                              <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                              {{ errors["mobile_number"] }}
                            </p>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group captcha-container">
                          <div id="wrongcaptch"></div>
                          <input name="modal_captcha_id" value="-1" type="hidden" class="form-control modal_captcha_id">
                          <div class="captcha" id="captcha1">To complete captcha, please select: <b class="modalCapText blue-text captchatext"></b><a href="javascript:void(0)"><i class="ph-arrows-clockwise-bold refreshCaptcha" v-on:click='resetCaptcha()' aria-hidden="true" data-modal-name="scheduleModal" title="Reload Captcha"></i></a></div>
                          <ul id="sortable">
                            <li class="modalCaptchaItem"><img class="captcha-img home" src="/assets/img/captcha/home-blue.png" data-goal="home" onclick="onChangeSelectedCaptcha('home', 'scheduleModal')"></li>

                            <li class="modalCaptchaItem"><img class="captcha-img car" src="/assets/img/captcha/car-blue.png" data-goal="car" onclick="onChangeSelectedCaptcha('car', 'scheduleModal')"></li>

                            <li class="modalCaptchaItem"><img class="captcha-img heart" src="/assets/img/captcha/heart-blue.png" data-goal="heart" onclick="onChangeSelectedCaptcha('heart', 'scheduleModal')"></li>

                            <li class="modalCaptchaItem"><img class="captcha-img airplane" src="/assets/img/captcha/airplane-blue.png" data-goal="airplane" onclick="onChangeSelectedCaptcha('airplane', 'scheduleModal')"></li>
                            
                            <li class="modalCaptchaItem"><img class="captcha-img education" src="/assets/img/captcha/education-blue.png" data-goal="education" onclick="onChangeSelectedCaptcha('education', 'scheduleModal')"></li>
                          </ul>
                          <!-- error message -->
                          <div class="form-group hf_input-container abc">
                            <p class="errorMessage" v-if="errors['recaptcha_error'] && errors['recaptcha_error'] !== ''">
                              <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                              {{ errors["recaptcha_error"] }}
                            </p>
                          </div>
                        </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group hf_input-container">
                            <div class="button-container">
                              <button :disabled="isFormSubmitting" href="javascript:void(0)" type="button" class="btn-primaryNoIcon lg-primarynoIcon"
                                v-on:click="validateScheduleASessionForm()">{{ !isFormSubmitting ? 'Schedule a session' : 'Please wait...' }}</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end schedule a Session modal -->
</template>
<script>
import { watch } from '@vue/runtime-core';
export default {
  data() {
    return {
      fullname: "",
      email_address: "",
      country_code: "91",
      mobile_number: "",
      errors: [],
      isScheduled: false,
      isFormSubmitting: false,
      maxCountryCodeLength: 3,
      maxMobileLength: 10
    };
  },
  watch: {
    fullname(userName) {
      this.fullname = userName;
      this.errors["fullname"] = '';
      if( !this.validateCharacters(this.fullname) ) // Check is valid entered name
        this.errors["fullname"] = "Please enter valid Name.";
    },
    email_address(emailAddress) {
      this.email_address = emailAddress;
      let isValidEmail = this.validateEmail(emailAddress);
      this.errors["email_address"] = '';
      if (!isValidEmail) // Check is valid entered email
        this.errors["email_address"] = "Please enter valid Email Address.";
    },
    country_code(countryCode) {
      this.country_code = $.trim(countryCode);
      if (countryCode.toString().length > this.maxCountryCodeLength) {
        this.country_code = $.trim(countryCode.toString().slice(0, this.maxCountryCodeLength));
      }
      if (this.country_code.toString().length > 0 && this.country_code.toString().length <= this.maxCountryCodeLength ){
        this.errors["mobile_number"] = '';
        if( this.country_code == 91 ) {
            this.maxMobileLength = 10;
            if( this.mobile_number.toString().length > 0 ) {
              if( !this.validateMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
                this.errors["mobile_number"] = "Please enter valid Mobile Number.";
            }
        }
        else{
          this.maxMobileLength = 13;
          // console.log(" international "+this.validateInternationalMobileNumber(this.mobile_number));
          if( this.mobile_number.toString().length > 0 ) {
            if( !this.validateInternationalMobileNumber(this.mobile_number) )
              this.errors["mobile_number"] = "Please enter valid Mobile Number.";
          }
        }
      }
      else
        this.errors["mobile_number"] = "Please enter valid Country Code";
    },
    mobile_number(mobileNumber){
      this.mobile_number = $.trim(mobileNumber);
      if( mobileNumber.toString().length > this.maxMobileLength ){
        this.mobile_number = $.trim(mobileNumber.toString().slice(0, this.maxMobileLength));
      }
      if( this.mobile_number.toString().length > 0 && this.country_code.toString().length > 0 ) {
        if( this.country_code == 91 ) {
          this.errors["mobile_number"] = '';
          if( !this.validateMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
            this.errors["mobile_number"] = "Please enter valid Mobile Number.";
        }
        else {
          // console.log(" international "+this.validateInternationalMobileNumber(this.mobile_number));
          this.errors['mobile_number'] = '';
          if( !this.validateInternationalMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
            this.errors["mobile_number"] = "Please enter valid Mobile Number.";
        }
      }
    },
  },
  methods: {
    async isMobileNumber(evt){
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async validateScheduleASessionForm(){
      // console.log("----schedule session form submit ------");
      var captchaId = $(this.$refs.scheduleModal).find('.modal_captcha_id').val();
// console.log(captchaId);
      var fullName = $.trim(this.fullname);
      var emailAddress = $.trim(this.email_address);
      var countryCode = $.trim(this.country_code);
      var mobileNumber = $.trim(this.mobile_number);
      // // LET'S VALIDATE FINAL FORM
      if( captchaId == 1 && this.validateCharacters(fullName) && this.validateEmail(emailAddress) && countryCode.toString().length > 0 && ((countryCode == '91' && this.validateMobileNumber(mobileNumber)) || (countryCode !== '91' && this.validateInternationalMobileNumber(mobileNumber))) ){

        this.isFormSubmitting = true;
        // API pending
        let userdata = {
          recaptcha_token: this.recaptchaToken,
          fullname: fullName,
          email: emailAddress,
          country_code: countryCode,
          mobile_number: mobileNumber
        }
        axios.post('schedule-a-session', userdata).then((apiResponse) => {
          // console.log(apiResponse);
          if (apiResponse.hasOwnProperty('data')) {
            if (apiResponse.data.hasOwnProperty('status') && apiResponse.data.status == 1) {
              this.isScheduled = true;
              // Prepare object for Clevertap events
              const [first, last] = fullName.split(' ');
              var firstName = ( first !== undefined ? first.charAt(0).toUpperCase() + first.slice(1) : '' );
              var lastName = ( last !== undefined ? last.charAt(0).toUpperCase()+ last.slice(1) : '' );
              // console.log("firstName :: "+firstName);
              // console.log("lastName :: "+lastName);
              var pageName = window.location.pathname;
              if( window.location.pathname == "/" )
                pageName = "/homepage";

              // console.log(pageName);
              // Add clevertap event here
              clevertap.profile.push({
                "Site": {
                  "Identity":emailAddress,
                  "Name": fullName,
                  "First Name":firstName,
                  "Last Name":lastName,
                  "Email": emailAddress,
                  "Phone": '+'+countryCode+mobileNumber,
                  "MSG-email": true,
                  "MSG-dndEmail": false
                }
              });
              clevertap.event.push("Schedule a Session",{
                "Name": fullName,
                "Email": emailAddress,
                "page name": pageName,
                "Source" : "HF Nashik" 
              });
            }
            else if( apiResponse.data.hasOwnProperty('status') && apiResponse.data.status == -2) {
              this.$refs.recaptcha.reset();
              this.isFormSubmitting = false;
              if( apiResponse.data.hasOwnProperty('field_type') && apiResponse.data.field_type !== '' )
                  this.errors[apiResponse.data.field_type] = apiResponse.data.message;
            }
            else{
              this.$refs.recaptcha.reset();
              this.isFormSubmitting = false;
              if( apiResponse.data.hasOwnProperty('message') && apiResponse.data.message!=="" )
                this.errors['form_error'] = apiResponse.data.message;
            }
          }
        }).catch(response => {
          console.log(response.data);
          this.isFormSubmitting = true;
        });
      }
      else {
        if (!this.validateCharacters(fullName))
          this.errors["fullname"] = "Please enter valid Name.";
        
        if (!this.validateEmail(emailAddress))
          this.errors["email_address"] = "Please enter valid Email Address.";
        
        if( (countryCode == '91' && !this.validateMobileNumber(mobileNumber)) ||
          (countryCode !== '91' && !this.validateInternationalMobileNumber(mobileNumber)) )
          this.errors["mobile_number"] = "Please enter valid Mobile Number.";
// console.log("captchaId::: "+captchaId);
        if ( captchaId != 1 )
          this.errors["recaptcha_error"] = "Please select valid captcha";
      }  // endif form validation
    },
    onModalHidden(){
      this.fullname = "";
      this.email_address = "";
      this.mobile_number = "";
    },
    onModalShown(){
      this.errors["fullname"] = "";
      this.errors["email_address"] = "";
      this.errors["mobile_number"] = "";
      this.errors["recaptcha_error"] = "";
      this.errors["form_error"] = "";
    },
    resetCaptcha() {
      this.errors["recaptcha_error"] = "";
    },
  },
  mounted() {
    $(this.$refs.scheduleModal).on("hidden.bs.modal", this.onModalHidden);
    $(this.$refs.scheduleModal).on("shown.bs.modal", this.onModalShown);
  }
};
</script>

